import React, { Fragment, useState } from "react";

import { useBaseDialog } from "@common/components/Dialog/BaseDialog";
import { MediaPreviewDialog } from "@common/components/Dialog/MediaPreviewDialog";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { useVideoPlayerSize } from "@common/hooks/useVideoPlayerSize";
import { Attachment } from "@common/models";
import { AttachmentButtons } from "@main/pages/shared/components/Attachments/AttachmentButtons/AttachmentButtons";
import * as Styled from "@main/pages/shared/components/Attachments/VideoAttachment/VideoAttachment.styles";
import ReactPlayer from "react-player";
import { CSSProperties } from "styled-components";

interface Props {
  style?: CSSProperties;
  attachment: Attachment;
  onRemoveClick?: (attachment: Attachment) => void;

  width?: number;
  height?: number;
}

export default function VideoAttachment({ style, attachment, onRemoveClick, width, height }: Props) {
  const [hover, setHover] = useState(false);
  const { modalPlayerSize, handleVideoReady } = useVideoPlayerSize();

  const modal = useBaseDialog({});

  const showModal = () => {
    modal.setOpen(true);
  };

  if (!attachment?.url) return <Fragment />;

  const renderVideoPreviewModal = () => {
    return (
      <MediaPreviewDialog modal={modal}>
        <Styled.PlayerWrapper>
          {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            <ReactPlayer
              url={attachment?.url}
              controls
              playing
              type="video/mp4"
              autoPlay
              width={modalPlayerSize ? `${modalPlayerSize.width}px` : "auto"}
              height={modalPlayerSize ? `${modalPlayerSize.height}px` : "90vh"}
              onReady={handleVideoReady}
            />
          }
        </Styled.PlayerWrapper>
      </MediaPreviewDialog>
    );
  };

  return (
    <Fragment>
      <Tooltip
        text="Play video"
        position="top"
        style={{ height: "100%" }}
      >
        <Styled.VideoContainer
          style={style}
          onClick={showModal}
          onMouseOver={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <Styled.Play />
          {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            <ReactPlayer
              url={attachment?.url}
              style={{ cursor: "pointer", borderRadius: "1rem", objectFit: "cover" }}
              width={width ?? "100%"}
              height={height ?? "100%"}
              playing={false}
              type="video/mp4"
              controls={false}
              showInfo={false}
              onReady={handleVideoReady}
            />
          }

          {hover && (
            <AttachmentButtons
              attachment={attachment}
              onRemoveClick={onRemoveClick}
            />
          )}
        </Styled.VideoContainer>
      </Tooltip>

      {renderVideoPreviewModal()}
    </Fragment>
  );
}
